import {
    Alert,
    Box,
    Card,
    CardContent,
    Divider,
    Grid,
    Paper,
    Typography,
} from '@mui/material';
import {
    getSizeLabel,
    getTotalWeightLabel,
    getTotalVolumeLabel,
    getVolumeLabel,
    getWeightLabel,
    MaritimeOrderInfo
} from "adoms-common-lib";
import React from 'react';
import InfoRow from '../atoms/InfoRow';



type MaritimeOrderGoodsProps = {
    order: MaritimeOrderInfo | undefined,
}

/**
 * オーダーの配送物一覧を表示する
 * @param props order:MaritimeOrderInfo
 */
const MaritimeOrderGoods: React.FC<MaritimeOrderGoodsProps> = (props) => {
    const order = props.order;
    const totalVolumeLabel = getTotalVolumeLabel(order?.goods ?? []);

    return (
        <Paper elevation={0}>
            {!order ? (
                <Alert severity="warning">配送物の情報が取得できませんでした</Alert>
            ) : order.goods?.length === 0 ? (
                <Alert severity="info">配送物がありません</Alert>
            ) : (
                <Grid container spacing={1}>
                    <Grid item>
                        <Grid container spacing={3}>
                            <Grid item>
                                <InfoRow
                                    label="合計重量"
                                    value={getTotalWeightLabel(order?.goods ?? [])}
                                    sx={{ borderBottom: 0, border: '1px solid', borderColor: 'grey.100', borderRadius: 1 }}
                                />
                            </Grid>
                            <Grid item>
                                <InfoRow
                                    label="合計体積"
                                    value={order?.goods?.length ? totalVolumeLabel : "ー"}
                                    sx={{ borderBottom: 0, border: '1px solid', borderColor: 'grey.100', borderRadius: 1 }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            {order?.goods?.map((goodInfo, idx) => {
                                const name = `荷物${idx + 1}：` + (goodInfo.name ?? '').trim();
                                const sizeLabel = getSizeLabel(goodInfo);
                                const volumeLabel = getVolumeLabel(goodInfo);
                                const weightLabel = getWeightLabel(goodInfo);

                                return (
                                    <Grid item xs={12} sm={6} md={4} key={goodInfo.id ?? `${idx}`}>
                                        <Card variant="outlined">
                                            <CardContent>
                                                <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
                                                    {name}
                                                </Typography>
                                                <Divider sx={{ mb: 1 }} />
                                                <Box sx={{ textAlign: 'left' }}>
                                                    <InfoRow label="サイズ（縦×横×高さ）" value={sizeLabel} />
                                                    <InfoRow label="体積" value={volumeLabel} />
                                                    <InfoRow label="重量" value={weightLabel} />
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Paper>
    );
}
export default MaritimeOrderGoods;